<script setup lang="ts">
import Box from '@uiKit/elements/Box.vue'
import Text from '@uiKit/elements/Text.vue'
import PropertyDetailSection from './PropertyDetailSection.vue'
import type { PropertyProcessStep } from '../types/propertyDetailTypes'

// WHAT'S THE PROCESS? (Figma 32590:61766) — four step cards, two per row.
// Cards keep their own height and centre on the row, as in the design.

interface Props {
  steps: PropertyProcessStep[]
}

defineProps<Props>()
</script>

<template>
  <PropertyDetailSection title="What’s the process?">
    <Box is="ol" class="pd-process">
      <Box
        v-for="step in steps"
        :key="step.step"
        is="li"
        direction="col"
        gap="10px"
        class="pd-process__card"
      >
        <Box align="center" justify="center" class="pd-process__badge">
          <Text type="body" color="inverse" is="span">Step {{ step.step }}</Text>
        </Box>
        <Box direction="col" gap="2">
          <Text
            type="heading"
            weight="semibold"
            color="var(--p-sliceal-gray-900)"
            is="h3"
            style="line-height: 24px"
            >{{ step.title }}</Text
          >
          <Text type="body" style="line-height: 20px">{{ step.description }}</Text>
        </Box>
      </Box>
    </Box>
  </PropertyDetailSection>
</template>

<style scoped>
.pd-process {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.pd-process__card {
  justify-content: center;
  padding: 16px;
  border: 1px solid var(--p-sliceal-gray-200);
  border-radius: 10px;
  background: var(--p-surface-0);
}

.pd-process__badge {
  align-self: flex-start;
  padding: 6px 12px;
  border-radius: 25px;
  background: var(--p-primary-700);
}

@media (max-width: 576px) {
  .pd-process {
    grid-template-columns: 1fr;
  }
}
</style>
